import api from '../../api/vo2api'

import BaseEntity from './BaseEntity';

let baseEntity = new BaseEntity({

    getEntityType() {
        return 'dashboard';
    },

    getEmptyName() {
        return '(empty name)'
    },

    getById(orgId) {
        return api.getDashboard(orgId)
    },

    deleteById() {
        return new Promise(resolve => resolve(null));
    },

    getItems() {
        return new Promise(resolve => resolve(null));
    },

    insertOrUpdate(orgId, entity) {
        if(entity) {
            //
        }
        return new Promise(resolve => resolve(null));
    },

    getEntityId(entity) {
        if(entity) {
            return entity.organizationId;
        }
        return null
    },
    augmentEntity( base, entity ) {
        if(entity) {
           //
        }
        return entity
    }
});

const state = {
    ...baseEntity.state,
};
const getters = {
    ...baseEntity.getters,
};
const actions = {
    ...baseEntity.actions,
};
const mutations = {
    ...baseEntity.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};